!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.id = a());
}(this, function () {
  "use strict";

  return [{
    locale: "id",
    pluralRuleFunction: function pluralRuleFunction(e, a) {
      return "other";
    },
    fields: {
      year: {
        displayName: "tahun",
        relative: {
          0: "tahun ini",
          1: "tahun depan",
          "-1": "tahun lalu"
        },
        relativeTime: {
          future: {
            other: "dalam {0} tahun"
          },
          past: {
            other: "{0} tahun yang lalu"
          }
        }
      },
      "year-short": {
        displayName: "thn.",
        relative: {
          0: "tahun ini",
          1: "tahun depan",
          "-1": "tahun lalu"
        },
        relativeTime: {
          future: {
            other: "dlm {0} thn"
          },
          past: {
            other: "{0} thn lalu"
          }
        }
      },
      month: {
        displayName: "bulan",
        relative: {
          0: "bulan ini",
          1: "bulan berikutnya",
          "-1": "bulan lalu"
        },
        relativeTime: {
          future: {
            other: "dalam {0} bulan"
          },
          past: {
            other: "{0} bulan yang lalu"
          }
        }
      },
      "month-short": {
        displayName: "bln.",
        relative: {
          0: "bulan ini",
          1: "bulan berikutnya",
          "-1": "bulan lalu"
        },
        relativeTime: {
          future: {
            other: "dlm {0} bln"
          },
          past: {
            other: "{0} bln lalu"
          }
        }
      },
      day: {
        displayName: "hari",
        relative: {
          0: "hari ini",
          1: "besok",
          2: "lusa",
          "-2": "kemarin dulu",
          "-1": "kemarin"
        },
        relativeTime: {
          future: {
            other: "dalam {0} hari"
          },
          past: {
            other: "{0} hari yang lalu"
          }
        }
      },
      "day-short": {
        displayName: "h",
        relative: {
          0: "hari ini",
          1: "besok",
          2: "lusa",
          "-2": "kemarin dulu",
          "-1": "kemarin"
        },
        relativeTime: {
          future: {
            other: "dalam {0} h"
          },
          past: {
            other: "{0} h lalu"
          }
        }
      },
      hour: {
        displayName: "Jam",
        relative: {
          0: "jam ini"
        },
        relativeTime: {
          future: {
            other: "dalam {0} jam"
          },
          past: {
            other: "{0} jam yang lalu"
          }
        }
      },
      "hour-short": {
        displayName: "jam",
        relative: {
          0: "jam ini"
        },
        relativeTime: {
          future: {
            other: "dalam {0} jam"
          },
          past: {
            other: "{0} jam lalu"
          }
        }
      },
      minute: {
        displayName: "menit",
        relative: {
          0: "menit ini"
        },
        relativeTime: {
          future: {
            other: "dalam {0} menit"
          },
          past: {
            other: "{0} menit yang lalu"
          }
        }
      },
      "minute-short": {
        displayName: "mnt.",
        relative: {
          0: "menit ini"
        },
        relativeTime: {
          future: {
            other: "dlm {0} mnt"
          },
          past: {
            other: "{0} mnt lalu"
          }
        }
      },
      second: {
        displayName: "detik",
        relative: {
          0: "sekarang"
        },
        relativeTime: {
          future: {
            other: "dalam {0} detik"
          },
          past: {
            other: "{0} detik yang lalu"
          }
        }
      },
      "second-short": {
        displayName: "dtk.",
        relative: {
          0: "sekarang"
        },
        relativeTime: {
          future: {
            other: "dlm {0} dtk"
          },
          past: {
            other: "{0} dtk lalu"
          }
        }
      }
    }
  }];
});